<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="26.08" height="23.066" viewBox="0 0 26.08 23.066">
    <g transform="translate(-1265.869 -832.136)">
      <path
        d="M1285.656,855.2c-2.341,0-3.89-.6-4.609-1.776-.79-1.294-.535-3.17.757-5.575,1.056-1.968-.138-11.817-.687-15.445l.988-.15c.208,1.369,1.985,13.45.58,16.067-.765,1.424-1.521,3.374-.785,4.582.545.9,1.918,1.318,3.982,1.295,2.637-.045,4.136-.426,4.716-1.2.663-.882.3-2.467-.324-4.786-1.253-4.639-.418-15.041.023-16.081l.92.39c-.36.876-1.166,11.027.022,15.431.7,2.6,1.094,4.4.157,5.647-.8,1.067-2.446,1.543-5.5,1.6Z"
      />
      <path
        d="M1281.42,849.762c-.075-.066-1.834-1.617-2.568-2.414a.854.854,0,0,1-.22-.64c.057-1.244,2.706-3.729,3.516-4.462l.67.742c-1.72,1.556-3.211,3.318-3.187,3.771.655.67,2.432,2.237,2.449,2.253Z"
      />
      <path
        d="M1269.679,849.55l-1-.024c.176-7.814,9.157-9.459,9.248-9.474l.171.984C1277.76,841.1,1269.836,842.562,1269.679,849.55Z"
      />
      <path
        d="M1269.349,850.683l-3.479-3.55.715-.7,2.989,3.05,3.48-1.58.414.91Z"
      />
    </g>
  </svg>
</template>
